(function () {

    var $htmlBody = $("html, body");
    var $backToTop = $("#back-to-top");

    function backToTop() {
        $backToTop.on("click", function (e) {
            $htmlBody.animate({
                scrollTop : 0
            }, 700);

            e.preventDefault();
        });
    }

    function hideShowBackToTop() {
        if ($backToTop.length) {
            var scrollTrigger = 1000;
            var scrollTop = $(window).scrollTop();

            if (scrollTop > scrollTrigger) {
                $backToTop.addClass("show");
            } else {
                $backToTop.removeClass("show");
            }
        }
    }

    backToTop();
    $(window).on("scroll", function () {
        hideShowBackToTop();
    });

})();